import { Affix, Button } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { ROUTES } from '../../../common/constants';
import useRouter from '../../../common/useRouter';

const VerificationPendingBar = () => {
  const { dispatch, getCurrentUser } = useContext(AppContext);
  const currentUser = getCurrentUser();
  const { navigate } = useRouter();
  return (
    <Affix offsetTop="0">
      <dt className="verification-pending-bar">
        {currentUser?.email ? (
          <div className="grace-bar-text">
            Your
            {!currentUser?.emailVerified && !currentUser?.numberVerified
              ? ' email id and mobile number '
              : `${!currentUser?.emailVerified ? ' email id ' : ' mobile number '}`}
            is not verified. Please&nbsp;
            <Button
              type="link"
              className="text-underline"
              onClick={() => {
                dispatch({ type: 'SET_SHOW_VERIFY_DETAILS_MODAL', data: true });
              }}
            >
              verify
            </Button>
            .
          </div>
        ) : (
          <div className="grace-bar-text">
            Please add and verify your email ID to ensure secure access to
            digiQC.&nbsp;
            <Button
              type="link"
              className="text-underline"
              onClick={() => {
                navigate(ROUTES.PROFILE);
              }}
            >
              Add
            </Button>
          </div>
        )}
      </dt>
    </Affix>
  );
};

export default VerificationPendingBar;
